import * as React from 'react';

import { Dropdown } from '../../packages/Dropdown';
import { ISelectorValue, ECategory } from '../../../types/share';

export interface ICategorySelectorProps {
  category: ECategory;
  values: ISelectorValue<ECategory>[];
  onChange(category: ECategory): void;
}

export function CategorySelector({ values, category, onChange }: ICategorySelectorProps) {
  return <Dropdown value={category} values={values} onChange={onChange} />;
}
